export default __webpack_public_path__ + "static/DEIPage-pattern-medium-neutral-def2aedf016360c41afc6258a161f52c.png";